import React, { Component, Fragment } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { HubConnectionBuilder } from '@aspnet/signalr';
import { API } from '../../Logic/API';

const ResultIndexName = "Round";
const DefaultLabel = "Wert";

export class BarChart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hubStarted : false,
            doNotListen: false,
            data: {},
        };
    }

    componentDidMount() {
        const hubConnection = new HubConnectionBuilder().withUrl("/hubs/results").build();
        this.setState({ resultHub: hubConnection },
            () => {
                this.state.resultHub.start().then(() => {
                    this.setState({ hubStarted: true },
                        () => {
                            this.startListeningTo(this.props.groupId);
                            this.refreshData(this.props.resource);
                        });
                });
                this.registerCallbacksOn(this.state.resultHub);
            });
    }

    startListeningTo(groupId) {
        if (!this.state.hubStarted) {
            setTimeout(() => this.startListeningTo(groupId), 500);
            return;
        }
        if (!groupId) {
            return;
        }
        if (this.state.doNotListen) {
            return;
        }
        this.state.resultHub.invoke("Register", groupId);
    }

    registerCallbacksOn(hub) {
        hub.on('Refresh',
            refresh => {
                if (!this.shouldRefresh(refresh)) {
                    return;
                }
                this.refreshData(this.props.resource);
            });
    }

    shouldRefresh(refresh) {
        if (refresh.GameId !== this.props.gameId) {
            return false;
        }
        if (refresh.GroupId !== this.props.groupId) {
            return false;
        }
        return true;
    }

    componentWillUnmount() {
        this.setState({ doNotListen: true });
        this.stopListeningTo(this.props.groupId);
    }

    stopListeningTo(groupId) {
        if (!groupId) {
            return;
        }
        if (!this.state.hubStarted) {
            return;
        }
        try {
            this.state.resultHub.invoke("Unregister", groupId);
        } catch (e) {

        }
    }

    componentWillUpdate(newProps) {
        if (this.props.groupId === newProps.groupId) {
            return;
        }
        this.stopListeningTo(this.props.groupId);
    }

    componentDidUpdate(oldProps) {
        if (this.props.groupId === oldProps.groupId) {
            return;
        }
        this.setState({ data: { } });
        this.startListeningTo(this.props.groupId);
        this.refreshData(this.props.resource);
    }

    refreshData(resource) {
        
        this.getData(resource,
            d => {
                this.setState({
                    data: d
                });
            });
    }

    getData(resource, setData) {
        if (!this.props.groupId) {
            return;
        }
        let uri = `/results/groups/${this.props.groupId}${resource}`;
        API.get(uri)
            .then(resp => resp.json())
            .then(data => {
                setData(data);
            })
            .catch(e => {

            });
    }

    render() {
        let keys = this.getKeys(this.state.data);
        let optionalProps = {};
        if (keys.length > 1) {
            optionalProps.legends = this.addLegend();
        }
        return (
            <Fragment>
                <h4 className="text-center">{this.props.label}</h4>
                <ResponsiveBar height={this.props.height}
                    data={this.toChartData(this.state.data)}
                    groupMode={this.props.grouped ? 'grouped' : 'stacked'}
                    keys={keys}
                    indexBy={ResultIndexName}
                    margin={{
                        "top": 50,
                        "right": 20,
                        "bottom": 50,
                        "left": 60
                    }}
                    colorBy={this.props.getColor}
                    enableLabel={false}
                    labelTextColor="hsl(0,100%,100%)"
                    axisLeft={{
                        "tickSize": 5,
                        "tickPadding": 5,
                        "tickRotation": 0,
                        "legend": this.renderName(this.state.data),
                        "legendPosition": "middle",
                        "legendOffset": -40
                    }}
                    axisBottom={{
                        "tickSize": 5,
                        "tickPadding": 5,
                        "tickRotation": 0,
                        "legend": "Spielrunden",
                        "legendPosition": "middle",
                        "legendOffset": 32
                    }}
                    padding={0.25}
                    {...optionalProps}
                />
            </Fragment>
        );
    }

    renderName(results) {
        if (!results) {
            return "";
        }
        switch (results.Unit) {
            case "Seconds":
                return "Sekunden";
            case "Pieces":
                return "Stück";
            case "Costs":
                return "Kosten";
            default:
                return "";
        }
    }

    toChartData(results) {
        let data = [];
        if (!results || !results.Rounds) {
            return data;
        }
        results.Rounds.forEach(r => {
            let roundData = {};
            roundData[ResultIndexName] = r.Round.toString();

            data.push(roundData);
            if (!r.Values) {
                return;
            }
            r.Values.forEach(v => {
                let label = this.getLabelOf(v);
                roundData[label] = v.Value;
            });
        });
        return data;
    }

    getKeys(results) {
        let keys = [];
        if (!results || !results.Rounds) {
            return keys;
        }
        results.Rounds.forEach(r => {
            if (!r.Values) {
                return;
            }
            r.Values.forEach(v => {
                let label = this.getLabelOf(v);
                if (keys.indexOf(label) > -1) {
                    return;
                }
                keys.push(label);
            });
        });
        
        return keys;
    }

    getLabelOf(value) {
        let label = value.Label || DefaultLabel;
        return removeUnit(label);
    }

    addLegend() {
        return [
            {
                dataFrom: "keys",
                anchor: "top-right",
                direction: "column",
                justify: false,
                translateX: -30,
                translateY: -40,
                itemSpacing: 10,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: "left-to-right",
                itemOpacity: 1,
                symbolSize: 18
            }
        ];
    }
}

function removeUnit(label) {
    return label.replace(/\s\[.+\]/, "");
}

export function tasksColor(v) {
    let label = removeUnit(v.id);
    switch (label) {
    case "Materiallager":
        return "hsl(325, 75%, 50%)";
    case "Vormontage Karton":
        return "hsl(225, 75%, 50%)";
    case "Vormontage Papierrollen":
        return "hsl(25, 75%, 50%)";
    case "Endmontage":
        return "hsl(0,0%,75%)";
    case "Qualitätssicherung":
        return "hsl(50, 75%, 50%)";
    case "Versandlager":
        return "hsl(125, 75%, 50%)";
    default:
        return "hsl(235, 75%, 50%)";
    }
}

export function cycleTimesColor(v) {
    return "hsl(235, 75%, 50%)";
}

export function productivityColor(v) {
    let label = removeUnit(v.id);
    switch (label) {
    case "Ausschuss":
        return "hsl(0, 100%, 50%)";
    default:
        return "hsl(235, 75%, 50%)";
    }
}


// WEBPACK FOOTER //
// ./src/components/Shared/BarChart.jsx